// extracted by mini-css-extract-plugin
export default {"element":"loader_element__crvQ3","spin":"loader_spin__JaLhW"};